import { PopperModifiers } from '@blueprintjs/core'

export const POPPER_MODIFIER_NO_ARROW: PopperModifiers = { arrow: { enabled: false } }
